import { render } from "./MiscDemo.vue?vue&type=template&id=50bdd625&scoped=true"
import script from "./MiscDemo.vue?vue&type=script&lang=js"
export * from "./MiscDemo.vue?vue&type=script&lang=js"

import "./MiscDemo.vue?vue&type=style&index=0&id=50bdd625&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bdd625"]])

export default __exports__